// ThankYou.js
import React from 'react';
import { useLocation } from 'react-router-dom';
import { Container, Typography } from '@mui/material';

const ThankYou = () => {
  const { state } = useLocation();
  const { orderId, amount, status } = state || {};

  return (
    <Container>
      <Typography variant="h4" style={{ marginTop: 30 }}>
        {status === 'success' ? 'Thank You!' : 'Payment Failed'}
      </Typography>
      {status === 'success' && (
        <>
          <Typography variant="h6">Your payment was successful.</Typography>
          <Typography variant="body1">Order ID: {orderId}</Typography>
          <Typography variant="body1">Amount Paid: ₹{amount}</Typography>
        </>
      )}
    </Container>
  );
};

export default ThankYou;